var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "modal-card" }, [
    _c("header", { staticClass: "modal-card-head has-background-black-ter" }, [
      _c("p", { staticClass: "modal-card-title has-text-light" }, [
        _vm._v("\n      " + _vm._s(_vm.$t("help.wmsexamples")) + "\n    "),
      ]),
      _vm._v(" "),
      _c("button", {
        staticClass: "delete is-medium",
        attrs: { title: _vm.$t("close") },
        on: {
          click: function ($event) {
            return _vm.closeModal()
          },
        },
      }),
    ]),
    _vm._v(" "),
    _c(
      "section",
      {
        staticClass:
          "modal-card-body has-background-dark has-text-light padded",
      },
      [
        _c("div", { staticClass: "wmsdiv" }, [
          _vm._v(
            "\n      " +
              _vm._s(this.baseUrl) +
              "?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image%2Fpng&"
          ),
          _c("span", { attrs: { id: "transparency" } }, [
            _vm._v("TRANSPARENT=" + _vm._s(this.transparency)),
          ]),
          _vm._v("&"),
          _c(
            "span",
            {
              staticStyle: { "white-space": "nowrap" },
              attrs: { id: "layer" },
            },
            [
              _vm._v(
                "LAYERS=" +
                  _vm._s(
                    this.$store.getters["config"].map.layers.baseLayers[
                      this.layer
                    ].layers[0].params.LAYERS
                  )
              ),
            ]
          ),
          _vm._v("&TILED=true&"),
          _c("span", { attrs: { id: "time" } }, [
            _vm._v("TIME=" + _vm._s(this.time.join(","))),
          ]),
          _vm._v("&"),
          _c("span", { attrs: { id: "width" } }, [
            _vm._v("WIDTH=" + _vm._s(this.w)),
          ]),
          _vm._v("&"),
          _c("span", { attrs: { id: "height" } }, [
            _vm._v("HEIGHT=" + _vm._s(this.h)),
          ]),
          _vm._v(
            "&CRS=" +
              _vm._s(this.epsg) +
              "&STYLES=&BBOX=" +
              _vm._s(this.bbox.bbox[0]) +
              "%2C" +
              _vm._s(this.bbox.bbox[1]) +
              "%2C" +
              _vm._s(this.bbox.bbox[2]) +
              "%2C" +
              _vm._s(this.bbox.bbox[3]) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("hr", { staticClass: "tight-hr" }),
        _vm._v(" "),
        _c("div", { staticClass: "content-div" }, [
          _c(
            "div",
            {
              staticClass: "properties-div",
              staticStyle: { position: "relative" },
            },
            [
              _c("b-field", { attrs: { label: "Transparency" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.transparency,
                      expression: "transparency",
                    },
                  ],
                  staticClass: "input tight-margin",
                  attrs: {
                    id: "transparency",
                    type: "text",
                    placeholder: "Transparency",
                  },
                  domProps: { value: _vm.transparency },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.transparency = $event.target.value
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "b-field",
                { attrs: { label: "Layer" } },
                [
                  _c(
                    "b-dropdown",
                    {
                      staticClass: "tight-margin",
                      attrs: { "aria-role": "list" },
                      model: {
                        value: _vm.layer,
                        callback: function ($$v) {
                          _vm.layer = $$v
                        },
                        expression: "layer",
                      },
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "button",
                          staticStyle: {
                            width: "295px",
                            "justify-content": "right",
                          },
                          attrs: {
                            slot: "trigger",
                            id: "layer",
                            type: "button",
                          },
                          slot: "trigger",
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.layers[_vm.layer].title)),
                          ]),
                          _vm._v(" "),
                          _c("b-icon", { attrs: { icon: "menu-down" } }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.layers, function (item, key) {
                        return _c(
                          "b-dropdown-item",
                          {
                            key: key,
                            attrs: { value: key, "aria-role": "listitem" },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(item.title) +
                                " \n              "
                            ),
                            item.layerType == "coh6"
                              ? _c("span", [
                                  _vm._v(_vm._s(_vm.$t(item.layerType))),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            item.layerType == "coh12"
                              ? _c("span", [
                                  _vm._v(_vm._s(_vm.$t(item.layerType))),
                                ])
                              : _vm._e(),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("b-field", { attrs: { label: "Time" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.time,
                      expression: "time",
                    },
                  ],
                  staticClass: "input tight-margin",
                  attrs: {
                    id: "time",
                    type: "text",
                    placeholder: "Time parameter",
                  },
                  domProps: { value: _vm.time },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.time = $event.target.value
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("b-field", { attrs: { label: "Width" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.w,
                      expression: "w",
                    },
                  ],
                  staticClass: "input tight-margin",
                  attrs: { id: "width", type: "text", placeholder: "Width" },
                  domProps: { value: _vm.w },
                  on: {
                    change: function ($event) {
                      return _vm.updateHeight()
                    },
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.w = $event.target.value
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("b-field", { attrs: { label: "Height" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.h,
                      expression: "h",
                    },
                  ],
                  staticClass: "input tight-margin",
                  attrs: { id: "height", type: "text", placeholder: "Height" },
                  domProps: { value: _vm.h },
                  on: {
                    change: function ($event) {
                      return _vm.updateWidth()
                    },
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.h = $event.target.value
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "button is-light send-request-button",
                  attrs: { type: "button" },
                  on: { click: _vm.loadImage },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("help.wmsexamples.sendrequest")) +
                      "\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("b-icon", {
                staticClass:
                  "icon-area-playground icon-on-load-loading loader-on-send",
                attrs: {
                  id: "loader",
                  size: "is-medium",
                  icon: "mdi mdi-loading",
                },
              }),
              _vm._v(" "),
              _c("b-icon", {
                staticClass: "icon-area-playground icon-on-load-success",
                attrs: {
                  id: "loaderSuccess",
                  size: "is-medium",
                  icon: "mdi mdi-check-circle-outline",
                },
              }),
              _vm._v(" "),
              _c("b-icon", {
                staticClass: "icon-area-playground icon-on-load-fail",
                attrs: {
                  id: "loaderFail",
                  size: "is-medium",
                  icon: "mdi mdi-alert-octagon-outline",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm._m(0),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticStyle: { width: "100%" }, attrs: { id: "frameDiv" } },
      [
        _c("div", { attrs: { id: "imageContainer" } }, [
          _c("canvas", { attrs: { id: "canvas" } }),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }